import React from 'react'

interface ContextProps {
  hasEMobilityWritingRights: boolean
}

export const EMobilityAccessRightsContext = React.createContext<ContextProps>({ hasEMobilityWritingRights: false })
